import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Time"
});
const _hoisted_1 = {
  class: "icon",
  width: "200px",
  height: "200.00px",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M512 896q163.008-4 271.488-112.512T896 512q-4-163.008-112.512-271.488T512 128q-163.008 4-271.488 112.512T128 512q4 163.008 112.512 271.488T512 896z m0 64q-190.016-4.992-316.512-131.488T64 512q4.992-190.016 131.488-316.512T512 64q190.016 4.992 316.512 131.488T960 512q-4.992 190.016-131.488 316.512T512 960zM480 256q14.016 0 23.008 8.992T512 288v256q0 14.016-8.992 23.008T480 576t-23.008-8.992T448 544V288q0-14.016 8.992-23.008T480 256z m0 256h256q32 0 32 32t-32 32h-256q-32 0-32-32t32-32z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var time = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "E:\\gitlab\\sgui-plus-icon\\packages\\vue\\src\\time.vue"]]);

export { time as default };
